import CustomerOrders from '../customerOrders/customerOrders';
export default function CustomersOrdersTab(props) {

    const projectId = props.projectId
return (
    <div>
        <CustomerOrders isInProject = {true} projectId = {projectId}></CustomerOrders>
    </div>
)};